import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.989 4.023A7.98 7.98 0 0 0 4 12.01a7.97 7.97 0 0 0 5.082 7.44c-.08-.641-.138-1.603.034-2.3.149-.619.938-3.972.938-3.972s-.263-.47-.263-1.19c0-1.11.641-1.946 1.442-1.946.687 0 1.007.515 1.007 1.122 0 .686-.446 1.705-.652 2.666-.183.79.4 1.442 1.19 1.442 1.42 0 2.507-1.488 2.507-3.65 0-1.912-1.374-3.251-3.33-3.251-2.267 0-3.606 1.705-3.606 3.468 0 .687.263 1.43.595 1.82.057.08.08.148.057.228-.057.264-.194.79-.228.916q-.052.223-.275.103c-.984-.47-1.614-1.934-1.614-3.102 0-2.529 1.82-4.84 5.276-4.84 2.77 0 4.933 1.98 4.933 4.611 0 2.633-1.74 4.98-4.132 4.98-.8 0-1.568-.424-1.82-.917 0 0-.4 1.523-.503 1.9-.183.698-.664 1.568-.984 2.095A7.99 7.99 0 0 0 20 12c-.011-4.406-3.594-7.989-8-7.989z"
    }, null, -1)
  ])))
}
export default { render: render }